import { memo, useEffect, useState } from "react";
import { Loader, SliderPanel } from "veronica-ui-component/dist/component/core";
import { useAdhocHoldOfCntrTracked } from "presentation/store/AdhocHoldOfContainer/AdhocHoldOfCntrProvider";
import { useAdhocHoldOfCntrVM } from "presentation/hook/AdhocHoldOfContainer/useAdhocHoldOfCntrVM";
import AdhocHoldOfCntrTablePanel from "./AdhocHoldOfCntrTablePanel";
import AdhocHoldOfCntrSearchPanel from "./AdhocHoldOfCntrSearchPanel";
import AdhocHoldReasonModal from "./AdhocHoldReasonModal";
import AdhocHoldOfCntrTitleBar from "./AdhocHoldOfCntrTitleBar";

const AdhocHoldOfCntrMaintenance: React.FC = () => {
    const [adhocHoldOfCntrState] = useAdhocHoldOfCntrTracked();
    const adhocHoldOfCntrVM = useAdhocHoldOfCntrVM();
    const [isLoading, setIsLoading] = useState(true);
    const { isShowSearchPanel } = adhocHoldOfCntrState;

    useEffect(() => {
        const initialScreen = async () => {
            setIsLoading(true);
            adhocHoldOfCntrVM.setIsSearchLoading(true);
            await Promise.allSettled([
                adhocHoldOfCntrVM.loadDropdownOption(),
            ]);
        };

        initialScreen().then((data) => {
            setIsLoading(false);
            adhocHoldOfCntrVM.setIsSearchLoading(false);
        }).catch(error => {
            setIsLoading(false);
            adhocHoldOfCntrVM.setIsSearchLoading(false);
        });

    }, [adhocHoldOfCntrVM]);

    if (isLoading) return <Loader Indicator="Stripe" size="Large" />;

    return <>
        <div className={`main-comp-wrapper${isShowSearchPanel ? '' : ' im-hide-side-form-draggable'}`}>
            {/* {isShowEditPanel && <AdhocHoldOfCntrEditPanel />} */}
            <AdhocHoldOfCntrTitleBar />
            {adhocHoldOfCntrState.isCancel && <Loader Indicator="Spinner" size="Medium" />}
            <SliderPanel
                isOpen={true}
                draggable={false}
                leftSectionWidth={isShowSearchPanel ? "30%" : "0%"}
                rightSectionWidth={isShowSearchPanel ? "70%" : "100%"}
                leftChildren={<AdhocHoldOfCntrSearchPanel />}
                rightChildren={<AdhocHoldOfCntrTablePanel />}
            />
            <div className='im-charge-data-search-confirm-modal-container'>
                {<AdhocHoldReasonModal />}
            </div>
        </div>
    </>
}

export default memo(AdhocHoldOfCntrMaintenance);